/**
 * Who staff contact when they are stuck — one place, so the login page, the
 * player's messages and any future screen all name the same people.
 *
 * Added for the company-wide cyber rollout (Sep 2026): ~490 staff had never
 * signed in, and the only contact anywhere was an HR address on the FAQ page,
 * which you cannot reach without signing in first. A shared mailbox rather than
 * a person, so it outlives whoever is running the platform.
 *
 * The emails name the same contact, but from their own copy: the edge function
 * (supabase/functions/drain-email-outbox) cannot import from src/. Change both.
 */
export const SUPPORT_NAME = 'IT Support';
export const SUPPORT_EMAIL = 'itsupport@hgconstruction.co.uk';
export const SUPPORT_MAILTO =
  `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent('HG Training Platform - help needed')}`;
